import { LoadingKey } from '../../app-active-loading/LoadingKey';
import { loginNewUser } from '../../http-login/loginNewUser';
import { handleLoginNewPortalSuccess } from '../../http-survey/handleLoginNewPortalResponse';
import { EndpointKey } from '../../http/EndpointKey';
import { getIsNewPortalCreated } from '../../store/app/selectors';
import { googleContactsActivateSync, googleContactsSaveConnection } from '../../store/auth/action-creators';
import { AuthActionTypes } from '../../store/auth/action-types';
import { getCurrentStep } from '../../store/flow/selectors';
import { Step } from '../../views/Step';
import { GoogleSyncAlertValue } from './acq136Constants';
import { activateSync, createConnection, handleGoogleContactsRequestError, handleLoginBeforeGoogleContactsSyncFailure, saveConnection, setGoogleContactsSyncAlertCookieForUserGuideAlert } from './acq136Utils';
export const EndpointsAcq136 = {
  [EndpointKey.LoginBeforeGoogleContactsSync]: {
    isStateOnlyTrigger: true,
    loadingKey: LoadingKey.LoginBeforeGoogleContactsSync,
    once: true,
    stateCheck: state => getIsNewPortalCreated(state) && getCurrentStep(state) === Step.GoogleContactsSync,
    method: loginNewUser,
    handleSuccess: (response, dispatch) => handleLoginNewPortalSuccess(dispatch),
    handleError: handleLoginBeforeGoogleContactsSyncFailure
  },
  [EndpointKey.GoogleContactsCreateConnection]: {
    reduxActionType: AuthActionTypes.GoogleContactsCreateConnection,
    loadingKey: LoadingKey.GoogleContactsSyncLoading,
    method: createConnection,
    handleSuccess: (response, dispatch) => {
      dispatch(googleContactsSaveConnection(response.id));
    },
    handleError: (error, dispatch) => {
      dispatch(handleGoogleContactsRequestError(EndpointKey.GoogleContactsCreateConnection));
    }
  },
  [EndpointKey.GoogleContactsSaveConnection]: {
    reduxActionType: AuthActionTypes.GoogleContactsSaveConnection,
    method: saveConnection,
    handleSuccess: (response, dispatch) => {
      dispatch(googleContactsActivateSync());
    },
    handleError: (error, dispatch) => {
      dispatch(handleGoogleContactsRequestError(EndpointKey.GoogleContactsSaveConnection));
    }
  },
  [EndpointKey.GoogleContactsActivateSync]: {
    reduxActionType: AuthActionTypes.GoogleContactsActivateSync,
    method: activateSync,
    handleSuccess: () => {
      setGoogleContactsSyncAlertCookieForUserGuideAlert(GoogleSyncAlertValue.success);
    },
    handleError: (error, dispatch) => {
      dispatch(handleGoogleContactsRequestError(EndpointKey.GoogleContactsActivateSync));
    }
  }
};